module.exports = __webpack_public_path__ + "img/5.8ec42bf8.jpg";